import React from 'react'

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    variant?: "primary" | 'secondary' | "outlined" | "strike";
}

const IconButton = (props: Props) => {
    const {
        ...buttonProps
    } = props;
    const variant = props.variant || 'primary';

    function getColorClassNames() {
        switch (variant) {
            case 'primary':
                return 'bg-primary-dark text-white hover:bg-primary disabled:bg-primary disabled:opacity-40 disabled:cursor-not-allowed';
            case 'secondary':
                return 'bg-utility-mutedLight text-primary-dark hover:bg-secondary-light';
            case 'outlined':
                return 'bg-white border-solid border-primary-dark border-[1px] text-primary-dark hover:bg-secondary-light';
            case 'strike':
                return 'bg-strike text-white border-solid border-solid border-strike border-[1px] hover:bg-strike-light disabled:bg-strike-dark disabled:opacity-50 disabled:cursor-not-allowed';
            default:
                return 'bg-primary-dark text-white hover:bg-primary disabled:bg-primary disabled:opacity-40 disabled:cursor-not-allowed';
        }
    }

    return (
        <button
            className={`${getColorClassNames()} py-[1.5px] box-border rounded-[10px] w-[44px] h-[44px] flex items-center justify-center`}
            {...buttonProps}
        >
            {props.children}
        </button>
    )
}

export default IconButton